<template>
    <div class="page page-product">
        <top-banner :img-url="require('../../assets/img/product/banner.jpg')"
                    :pageTitle="$i18n.t('common.核心业务')"></top-banner>
        <div class="container">
            <div class="row bread">
                <section-title :title="$i18n.t('common.核心业务')" ></section-title>
                <div class="row" v-if="typeId!=0">
                    <div class="title" @click="typeId=0">{{$i18n.t('common.核心业务')}}</div>
                    <Icon type="ios-arrow-forward" />
                    <div class="text">{{typename[typeId]}}</div>
                </div>
            </div>
        </div>

        <!--&lt;!&ndash;核心业务&ndash;&gt;-->
        <!--<div class="poster" v-if="typeId==0">-->
            <!--<div v-for="(item,index) in navList" :key="index" class="row nav-item" :style="{position:'absolute',left:(item.x*100-2000)/1920+'vw',bottom:item.y*100/1920+'vw'}" @click="typeId=item.typeId">-->
                <!--<div class="breathe-bg"><div class="breathe-btn" :style="{'animation-delay':index+'s'}"></div></div>-->
                <!--<div class="line"></div>-->
                <!--<div class="title">{{item.key}}</div>-->
            <!--</div>-->
        <!--</div>-->
        <!--核心业务-->
        <div class="poster" v-if="typeId==0">
            <div v-for="(item,index) in navList" :key="index" class="row nav-item scaleview" :style="{position:'absolute',left:(item.x*100-2000)/1920+'vw',bottom:item.y*100/1920+'vw'}" >
                <router-link :to="{path:'/productDetail',query:{typeId:item.typeId}}" class="row">
                    <div class="line" :style="{width: 220*100/1920+'vw'}"></div>
                    <div class="breathe-bg"><div class="breathe-btn" :style="{'animation-delay':index+'s'}"></div></div>
                    <div class="title">{{item.key}}</div>
                </router-link>

            </div>
        </div>
        <!--产品分类详情-->
        <div class="container" v-else>
            <div class="poster" :style="{'background-image':'url(' +posterList[typeId]+ ')'}">
                <div v-for="(item,index) in productPisitionList[typeId]" :key="index" class="row nav-item" :style="{position:'absolute',left:item.x+'px',bottom:item.y+'px'}" >
                    <ronter-link :to="{path:'/productDetail',query:{typeId:item.typeId}}" class="title">{{item.key}}</ronter-link>
                </div>
            </div>
        </div>
        <!--产品列表-->
        <div class="container product-list row">
            <div class="product-item column" v-for="(item,index) in productList">
                <!--<div class="poster" :style="{'background-image':'url(' +item.url+ ')'}" :class="[index+1==typeId ? 'active':'','poster']" @click="typeId=index+1"></div>-->

                <router-link :to="{path:'/productDetail',query:{typeId:item.typeId}}" class="title">
                    <div class="poster" :style="{'background-image':'url(' +item.url+ ')'}" :class="[index+1==typeId ? 'active':'','poster']" ></div>
                </router-link>

                <router-link :to="{path:'/productDetail',query:{typeId:item.typeId}}" class="titles">
                    <div class="title">{{item.title}}</div>
                    <div class="contents">
                        <pre class="content">{{item.content}}</pre>
                    </div>
                </router-link>

            </div>
        </div>
    </div>
</template>


<script>

    export default {
        data(){
            return{
                typeId:0,
                typename:['',this.$i18n.t('common.装饰条'),this.$i18n.t('common.内外饰件'),this.$i18n.t('common.车身金属件'),this.$i18n.t('common.车身电子')],
                posterList:['',require("../../assets/img/product/b-1.jpg"),require("../../assets/img/product/b-2.jpg"),require("../../assets/img/product/b-3.jpg"),require("../../assets/img/product/b-4.jpg")],
                navList:[{
                    x:'920',
                    y:'660',
                    key:this.$i18n.t('common.车身金属件'),
                    typeId:'3'
                },{
                    x:'990',
                    y:'595',
                    key:this.$i18n.t('common.内外饰件'),
                    typeId:'2'
                },{
                    x:'1060',
                    y:'530',
                    key:this.$i18n.t('common.装饰条'),
                    typeId:'1'
                },{
                    x:'1130',
                    y:'455',
                    key:this.$i18n.t('common.车身电子'),
                    typeId:'4'
                },],
                productPisitionList:[[],[{
                    x:'477',
                    y:'420',
                    key:this.$i18n.t('product.productPisitionList[0][0]'),
                    typeId:'1'
                }],[{
                    x:'231',
                    y:'144',
                    key:this.$i18n.t('product.productPisitionList[1][0]'),
                    typeId:'2'
                }],[{
                    x:'886',
                    y:'210',
                    key:this.$i18n.t('product.productPisitionList[2][0]'),
                    typeId:'3'
                }],[{
                    x:'154',
                    y:'430',
                    key:this.$i18n.t('product.productPisitionList[3][0]'),
                    typeId:'4'
                }]],
                productList:[{
                    url:require("../../assets/img/product/a-1.png"),
                    title:this.$i18n.t('common.装饰条'),
                    content:this.$i18n.t('product.productList[0]'),
                    typeId:1
                },{
                    url:require("../../assets/img/product/a-2.png"),
                    title:this.$i18n.t('common.内外饰件'),
                    content:this.$i18n.t('product.productList[1]'),
                    typeId:2
                },{
                    url:require("../../assets/img/product/a-3.png"),
                    title:this.$i18n.t('common.车身金属件'),
                    content:this.$i18n.t('product.productList[2]'),
                    typeId:3
                },{
                    url:require("../../assets/img/product/a-4.png"),
                    title:this.$i18n.t('common.车身电子'),
                    content:this.$i18n.t('product.productList[3]'),
                    typeId:4
                }]
            }

        }
    }
</script>
<style lang="scss" scoped>
    .row{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .column{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .poster{
        width: 100vw;
        height: 31.25vw;
        background: url("../../assets/img/product/poster.jpg");
        background-position:center;
        background-size: cover;
        position: relative;

        .title{
            height: vw(35);
            /*margin-left: vw(-21);;*/
            padding:0 vw(30);;
            color: #ffffff;
            font-size:  vw(17);
            line-height: vw(35);
            background: #000000;
            text-align: center;
            border-radius: vw(4);
            opacity: 0.6;
            cursor: pointer;
        }
        .line{
            width: vw(20);
            height: 0px;
            border-bottom: 2px dotted #1CAAFF;
            opacity: 0.8;
            -webkit-transform: rotate(-25deg);
            transform: rotate(-25deg);
            -webkit-transform-origin: 100%;
            transform-origin: 100% 100%;
            margin-top: 2px;

        }
    }

    .breathe-bg{
        width:vw(13);
        height:vw(13);
        background: #fff;
        border-radius:13px;
        z-index: 100;
    }
    .breathe-btn {
        cursor: pointer;
        width:vw(13);
        height:vw(13);
        border:1px solid #2b92d4;
        border-radius:13px;
        text-align:center;
        cursor:pointer;
        box-shadow:0 1px 2px rgba(0,0,0,.3);
        background: #303234;
        background-image: -webkit-gradient(linear,left top,left bottom,from(#6cc3fe),to(#2b92d4));
        -webkit-animation-timing-function:ease-in-out;
        -webkit-animation-name:breathe;
        -webkit-animation-duration:1700ms;
        -webkit-animation-iteration-count:infinite;
        -webkit-animation-direction:alternate;

    }
    @-webkit-keyframes breathe {
        0% {
            opacity: 0.5;
            box-shadow:0 1px 2px rgba(255,255,255,0.1);
        }
        100% {
            opacity: 1;
            border: 1px solid rgba(28,170,255,1);
            box-shadow:0 3px 30px $primary-color;
        }
    }
    .container {

    .poster {
        width: 100%;
        height: 700px;
        background: url("../../assets/img/product/b-1.jpg");
        background-position: center;
        background-size: cover;
        position: relative;

    .title {
        height: vw(40);
        padding:0 vw(20);
        border: 2px solid $primary-light-color;
        color: #ffffff;
        font-size: vw(18);
        line-height: vw(36);
        background: #000000;
        text-align: center;
        border-radius: vw(8);
        opacity: 0.6;
        cursor: pointer;
    }
    }
    }
    /*产品列表*/
    .product-list{
        margin-top: 89px;
        justify-content: space-between;
        align-items: flex-start;
        .product-item{
            cursor: pointer;
            width: 250px;
            .poster{
                width: 160px;
                height: 160px;
                border-radius: 50%;
                background-position: center;
                background-size: cover;
                transition: all 0.3s ease;
            }
            .poster:hover{
                border: 4px solid #ffffff;
                box-shadow: 0 0 0 6px $primary-color;
            }
            .active{
                border: 4px solid #ffffff;
                box-shadow: 0 0 0 6px $primary-color;
            }
            .titles{

            }
            .title{
                font-size:$font-size-large;
                font-weight:500;
                color:#000000;
                margin-top: 37px;
            }
            .contents{
                min-width: 100px;
            }
            .content{
                font-size:$font-size-small;
                color: $text-color;
                margin-bottom: 90px;
            }
        }
    }
    .bread{
        justify-content: space-between;
        font-size:$font-size-large;
        .title{
            color: #999999;
            cursor: pointer;
        }
        .text{
            color: #1CAAFF;
        }
    }
</style>
